// @stayai — §2c4 spill fix: Fly Bundles "Buy More, Save More" Subscribe & Save dropdown
// enumerates product.selling_plan_groups client-side with no app_id filter. 
// Active app id: single source snippets/active-subscription-app-id.liquid, passed in as
// window.STAYAI_ACTIVE_APP_ID from theme.liquid. 
(function () {
  var ACTIVE_APP_ID = String(window.STAYAI_ACTIVE_APP_ID || '').trim();
  if (!ACTIVE_APP_ID) return; // no toggle value -> do nothing
  var DEBUG = window.STAYAI_FLYBUNDLES_DEBUG || false;

  function log() {
    if (DEBUG) console.log.apply(console, ['>>> [flybundles-filter]'].concat(Array.prototype.slice.call(arguments)));
  }

  function buildPlanMap() {
    var groups = window.ALL_SELLING_PLAN_GROUPS || [];
    var map = {};
    groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) {
        map[String(p.id)] = g.app_id;
      });
    });
    return map;
  }

  function filterSelect(select, planMap) {
    if (select.dataset.stayFiltered) return;
    var selectedForeign = false;
    Array.prototype.slice.call(select.options).forEach(function (opt) {
      var appId = planMap[opt.value];
      if (appId !== undefined && appId !== ACTIVE_APP_ID) {
        if (opt.selected) selectedForeign = true;
        opt.remove();
      }
    });
    if (selectedForeign || !select.value) {
      var fallback = select.querySelector('option');
      if (fallback) {
        select.value = fallback.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        var wrapper = select.closest('.gfbDropdownWithCustomIcon');
        var label = wrapper && wrapper.querySelector('.gfbSelectedOption');
        if (label) label.textContent = fallback.dataset.sellingPlanName || fallback.textContent;
      }
    }
    select.dataset.stayFiltered = 'true';
    log('filtered', select);
  }

  function scan(root, planMap) {
    root.querySelectorAll("select.gfbSelect[data-is-event-registered='REGISTERED']").forEach(function (select) {
      filterSelect(select, planMap);
    });
  }

  function init() {
    var root = document.querySelector('.gfbPageWrapper');
    if (!root) return;
    var planMap = buildPlanMap();
    if (!Object.keys(planMap).length) {
      log('no ALL_SELLING_PLAN_GROUPS found — skipping filter');
      return;
    }
    scan(root, planMap);
    new MutationObserver(function () {
      scan(root, planMap);
    }).observe(root, { childList: true, subtree: true });
  }

  function waitForRoot(attempts) {
    var root = document.querySelector('.gfbPageWrapper');
    if (root) return init();
    if (attempts <= 0) return log('gfbPageWrapper never appeared — exiting');
    setTimeout(function () { waitForRoot(attempts - 1); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForRoot(40); });
  } else {
    waitForRoot(40);
  }
})();
